/*
 * @Author: xuejian3721
 * @Date: 2023-10-24 09:07:49
 * @LastEditors: xuejian3721
 * @LastEditTime: 2023-11-16 09:53:38
 */
const resCode = {
  // 响应成功code
  success: 1,
  // 会话已关闭
  dialogClosed: 10004,
  // 进线失败
  incomingFailure: 341
};

export { resCode };
